import { useAuthContext } from '../contexts/AuthContext';

/**
 * Custom hook to access Auth Context
 * @returns {object} - Auth state and actions
 */
export const useAuth = () => {
  const context = useAuthContext();
  return context;
};

export default useAuth;
